import { ENVIRONMENT_GLOBAL } from "./global";

export const environment = {
    ...ENVIRONMENT_GLOBAL,
    env: "DoctorProx 1.4.13",
    // Ip for send the ip hubio in the emails
    protocol: "https://",
    // the first position is taken as default subdomain
    subdomains: ["app", "gyc", "mpc", "centromater", "hubio", "schiller"],
    saludSubdomains: ["app","gyc", "mpc", "centromater", "hubio", "schiller"],
    hubioIp: "doctorprox.com",
    saludproxIp: "app.saludprox.com",
    saludDomain: "saludprox.com",
    gatewayIp: "doctorprox.com",
    gatewayPort: "443",
    production: true,
    qa: false,
    defaultUrl: "https://app.doctorprox.com:443",
    directoryUrl: "https://directory.saludprox.com",

    googleMapsURLAPI: "https://maps.googleapis.com/maps/api/geocode/json",
    googleMapsAPIKey: "AIzaSyDw2L7_Sj14ztkFsxf_ssx4nyzcSsvvgTg",  // API from Keys & credentials section in google cloud console
    googleClientId: "324695723410-uf4120kdtd03g9d2hcueksg5qvbn9pjc.apps.googleusercontent.com",
    googleScope: "openid email profile https://www.googleapis.com/auth/calendar",

    openPaySubdomain: "openpay.doctorprox.com",
    openPayMicroserviceUser: "hubio",
    openPayMicroservicePassword: "Hubio123$",

    // Limit of inactive time in minutes
    idleTimeLimit: 60,

    //Enable disable financial module
    financialModuleEnabled: true,
    clientId: "swagger",
    clientSecret: "Th8E5LLop7say4HGXcLPCRJP12gEInPi",
    appsSubdomains:{
        operational:{
            saludProx:"op",
            gyc:"",
            mpc:"",
            centromater:"",
            hubio:"",
            schiller:""
        },
        saludProx:{
            saludProx:"app",
            gyc:"gyc",
            mpc:"mpc",
            centromater:"centromater",
            hubio:"hubio",
            schiller:"schiller"
        },
        reports:{
            saludProx:"report",
            gyc:"",
            mpc:"",
            centromater:"",
            hubio:"",
            schiller:""
        }
    },

    payPalOauthURL:
        "https://api.sandbox.paypal.com/v1/oauth2/token?grant_type=client_credentials",
    payPalALLTCClientId:
        "AUkva9CmwWXdokDr1gloMVNcvwFKKlcn5zt4P25B0aLwnDma7xyEcBMP09XG5CYMhpODO2XdUUb",
    payPalALLTCSecret:
        "ENP5On8-oRShQEIcGj6IGjCLpUzbx1aAalA6Bd1Hv9-ogN51wvGtyA4J8zrrSx6gvosAKTulxjWSAZFU",
    paypalsubscriptionApi: "https://api.sandbox.paypal.com/v1/billing/subscriptions/",
    payPalAPI: "https://api.sandbox.paypal.com/v2/checkout/orders/",

    stripeAPIUrl: "https://api.stripe.com/v1/payment_intents",
    stripeALLTCPublicKey:
        "pk_live_51LuhHGGDQ22VjfOxBRtSzF5ZQN7mix2JUAZcYJojG8DsELXPkj4RUBYfqG5T0q2G6GegjAIT5JE844yAqqJXT2nW008fADt3Ko",

    stripeFCareCPublicKey:
        "pk_live_51LuhHGGDQ22VjfOxBRtSzF5ZQN7mix2JUAZcYJojG8DsELXPkj4RUBYfqG5T0q2G6GegjAIT5JE844yAqqJXT2nW008fADt3Ko",

    // Google Cloud Fraud Defense (reCAPTCHA Enterprise) - policy-based challenge keys.
    // Site keys are public by design (unlike the server-side API key configured in fc-sign-up).
    recaptchaEnabled: true,
    recaptchaSiteKeys: {
        production: "6LcTrn0tAAAAAJFdppzJgY1zV7guIVyWjnbPfz0T",
        nonProd: "6LenFY8tAAAAAORTQEZW3DxzLinDNVdAAXx4Jb9A",
    },

};

/**
 * Picks the reCAPTCHA site key based on hostname, mirroring the subdomain-sniffing
 * pattern used by getDataOiauth() in auth.ts. Defaults to the non-prod key (domain
 * verification disabled) for anything not a recognized production subdomain -
 * localhost, QA, previews, and the Capacitor Android WebView origin (https://localhost).
 */
export const getRecaptchaSiteKey = (): string => {
    const hostnameSplited = window.location.hostname.split(".");
    const firstSegment = hostnameSplited[0];
    const isProductionSubdomain =
        environment.subdomains.includes(firstSegment) ||
        environment.saludSubdomains.includes(firstSegment);
    return isProductionSubdomain
        ? environment.recaptchaSiteKeys.production
        : environment.recaptchaSiteKeys.nonProd;
};
